<template>
  <div>
    <div>
      <div class="container py-10">
        <div class="d-flex flex-wrap justify-content-around align-items-top">

          <!-- Filtre Outil à sélectionner -->
          <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 p-0 m-0">
            <theme-select class="m-0" v-on:selection-change="onThemeChange" :themeId="parseInt(filters.theme)"></theme-select>
          </div>

          <!-- Filtre Parcours commencés/découvrir -->
          <div class="d-flex justify-content-center">
            <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 p-0 m-0">
              <v-btn-toggle v-model="filters.toggleGroup" group color="#1d71b8" mandatory>
                <v-btn value="allCourses" style="border-radius:5px; height: 50px" class="my-0">
                  {{$t('course.all')}}<br>
                  {{$t('course.all2')}}
                </v-btn>
              
                <v-btn value="start" style="border-radius:5px; height: 50px" class="my-0">
                  {{$t('course.start')}}<br>
                  {{$t('course.start2')}}
                </v-btn>
              
                <v-btn value="notStart" style="border-radius:5px; height: 50px" class="my-0">
                  {{$t('course.nostart')}}<br>
                  {{$t('course.nostart2')}}
                </v-btn>
              </v-btn-toggle>
            </div>
          </div>
      
        </div>
      </div>
      

      <!-- liste des parcours -->
      <div>
        <div v-if="filters.theme">
          <h3 class="text-center mb-4">Parcours: {{ filters.theme.title }}</h3>
          <!--  <div><h5>{{ visibleCourses.length }} parcours contenant l'outil :</h5></div> -->
        </div>

        <div v-for="course in visibleCourses" :key="course.id">
          <CourseItem :course="course"></CourseItem>
        </div>

        <!--Si aucune video à afficher-->
        <div v-if="visibleCourses.length === 0">
          <p>Aucun parcours à afficher</p>
        </div>

      </div>


    </div>
  </div>
</template>

<style scoped>

</style>

<script>
import Api from "@/core/services/api.service";
import CourseItem from "@/components/course/courseItem";
import ThemeSelect from "@/components/theme/themeSelect";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import isInTheme from "@/core/utils/isInTheme";
import {courseProgression} from "@/core/utils/course";
import {mapGetters} from "vuex";

export default {
  name: "listCourses",
  components: {
    ThemeSelect,
    CourseItem
  },

  props: {
    localStorageThemeKey: { type: String, default: 'video-list-theme' },
  },

  data: instance => ({
    courses: [],
    visibleCourses: [],
    pagination: {
      currentPage: 1,
      pagesNumber: 0,
    },
    filters: {
      theme: localStorage[instance.localStorageThemeKey] ?? null,
      toggleGroup: 'allCourses',
    },
    
  }),
  computed: {
    ...mapGetters(["currentUser"]),
  },
  watch: {
    filters: {
      handler: function () {
        this.filtersUpdated();
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$i18n.t('sidebar.coursesMenu') }]);
    if (this.localStorageThemeKey) {
      this.getAllCourses()
    }
  },
  methods: {
    getAllCourses() {
      Api.get("courses?pagination=false").then(courses => {
        this.courses = courses.data["hydra:member"]; //On rempli le tableau initialement vide par ce qu'on a récupéré
        this.visibleCourses = this.courses;
      });
    },
    onThemeChange(theme) {
      this.filters.theme = theme;
      if (this.filters.theme !== null) {
        localStorage[this.localStorageThemeKey] = this.filters.theme.id;
      } else {
        localStorage.removeItem(this.localStorageThemeKey);
      }
    },

    filtersUpdated() {
      let visibleCourses = this.courses;

      if (this.filters.theme !== null) {
        // Recherche récursive sur l'ensemble des parcours du thème sélectionné
        visibleCourses = visibleCourses.filter(c => isInTheme(c.theme, this.filters.theme));
      }
      if (this.filters.toggleGroup === 'start') {
        visibleCourses = visibleCourses.filter(c => courseProgression(this.currentUser, c.videos) > 0);
      }
      if (this.filters.toggleGroup === 'notStart') {
        visibleCourses = visibleCourses.filter(c => courseProgression(this.currentUser, c.videos) <= 0);
      }

      this.visibleCourses = visibleCourses;
    }
  },
  metaInfo: {
    // Les enfants peuvent remplacer le titre.
    title: 'Parcours',
    meta: [
      {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {name: 'description', content: 'Parcours de l\'application TellMeGenius.'}
    ]
  }
};
</script>
